import LineGradient from "../components/LineGradient";
import { motion } from "framer-motion";

const CaseStudies = () => {
  return (
    <section id="case studies" className="pt-32 pb-16">
      {/* HEADING */}
      <motion.div
        className="md:w-1/3 text-center md:text-left mx-auto"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.5 }}
        variants={{
          hidden: { opacity: 0, x: -50 },
          visible: { opacity: 1, x: 0 },
        }}
      >
        <p className="font-playfair font-semibold text-4xl mb-5 text-red">
          Case Studies
        </p>
        <LineGradient width="mx-auto w-2/5" />
        <p className="mt-10">
          Discover how our solutions have driven success for our clients. From
          templates to AI-powered tools, explore the stories behind the
          numbers.
        </p>
      </motion.div>

      {/* TESTIMONIALS */}
      <div className="md:flex md:justify-between gap-8 mt-16">
        {[
          {
            id: 1,
            bgGradient: "bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600",
            text: "The e-commerce template streamlined our workflow and increased our conversion rates by 30%. A game changer for our business!",
          },
          {
            id: 2,
            bgGradient: "bg-gradient-to-r from-red-400 via-red-500 to-red-600",
            text: "AI-powered chatbots improved our customer support efficiency by 40%. Customers are happier, and our team is more productive.",
          },
          {
            id: 3,
            bgGradient: "bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600",
            text: "The admin dashboard revolutionized our operations management. It's intuitive and powerful. Highly recommended!",
          },
        ].map(({ id, bgGradient, text }, index) => (
          <motion.div
            key={id}
            className={`relative ${bgGradient} max-w-[400px] h-[350px] flex flex-col justify-center items-center p-8 mx-auto rounded-lg shadow-lg transition-transform transform hover:scale-105`}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            transition={{ delay: index * 0.2, duration: 0.6 }}
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
          >
            <p className="font-playfair text-6xl text-white mb-4">“</p>
            <p className="text-center text-xl text-white">{text}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default CaseStudies;
